import { Link } from "@msuite/ui/link";
import { guardString } from "@msuite/utils/strings";

/** Props Interface */
interface PaymentSupplierCellProps {
	supplier: string | null;
	contactId: string | null;
}

/** The supplier paid, opening its contact in a new tab — the modal stays as it is. */
export function PaymentSupplierCell({ supplier, contactId }: PaymentSupplierCellProps) {
	/** Guard */
	if (!contactId) return guardString(supplier);

	/** Render */
	return <Link href={`/contacts/${contactId}`}>{guardString(supplier)}</Link>;
}
